export default __webpack_public_path__ + "static/media/profile.fbc455a4.svg";